module.exports = __webpack_public_path__ + "static/media/teygja_brjostvodvar_small.39370c3f.png";